import { render, staticRenderFns } from "./btnIcon.vue?vue&type=template&id=23aa9f32&"
import script from "./btnIcon.vue?vue&type=script&lang=ts&"
export * from "./btnIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports